import React, { useState, useMemo } from 'react'

import styled from 'styled-components'
import { FaStar } from 'react-icons/fa6'

const StarRatings = ({ answer, handleRating }) => {
  const stars = useMemo(() => Array(5).fill(0), [])
  const colors = useMemo(
    () => ({
      orange: '#F2C265',
      grey: 'a9a9a9',
    }),
    []
  )

  const [rating, setRating] = useState(answer)

  const handleClickStar = (value) => {
    handleRating(value)
    setRating(value)
  }

  return (
    <>
      {stars.map((_, index) => {
        return (
          <Stars key="">
            <FaStar
              key={index}
              size={24}
              value={rating}
              onChange={(e) => setRating(e.target.value)}
              color={rating > index ? colors.orange : colors.grey}
              onClick={() => handleClickStar(index + 1)}
              cursor="pointer"
            />
          </Stars>
        )
      })}
    </>
  )
}

const Stars = styled.div`
  display: flex;
  gap: 1rem;
`

export default StarRatings
